import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const Container = styled(Wrapper)`
  gap: ${theme.spacing.md};
`

export const TableWrapper = styled.div`
  display: grid;
`

const BaseCellItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};

  span {
    line-height: 50%;
  }
`

export const OrderNumber = styled(BaseCellItem)``

export const OrderNumberSAP = styled(BaseCellItem)``

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.md};
`

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.xm};
  flex-wrap: wrap-reverse;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;
  }
`

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.neutral['100']};
  height: 312px;
`

export const TablePad = styled.div`
  width: 4vw;
`

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`
